import {
  McpUsageHistoryRO,
  McpUsageSummaryRO,
  UpdateMcpCreditsDTO,
} from "@intentsify/dto";
import { apiService, Endpoints } from "api";

const getMcpUsageSummary = async (
  companyId: number,
): Promise<McpUsageSummaryRO> => {
  const { data } = await apiService.get<McpUsageSummaryRO>(
    Endpoints.Companies.Get.McpUsage(companyId),
  );
  return data;
};

const getMcpUsageHistory = async (
  companyId: number,
): Promise<McpUsageHistoryRO> => {
  const { data } = await apiService.get<McpUsageHistoryRO>(
    Endpoints.Companies.Get.McpUsageHistory(companyId),
  );
  return data;
};

const updateMcpCredits = async (
  companyId: number,
  totalCredits: number,
): Promise<void> => {
  const body: UpdateMcpCreditsDTO = { totalCredits };
  await apiService.put(Endpoints.Companies.Put.McpCredits(companyId), body);
};

export { getMcpUsageSummary, getMcpUsageHistory, updateMcpCredits };
